import { render, staticRenderFns } from "./list-conjunto.vue?vue&type=template&id=ab15cabe"
import script from "./list-conjunto.vue?vue&type=script&lang=js"
export * from "./list-conjunto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports